import { render } from "./GridKPIAgenti.vue?vue&type=template&id=414b650a&scoped=true&ts=true"
import script from "./GridKPIAgenti.vue?vue&type=script&lang=ts"
export * from "./GridKPIAgenti.vue?vue&type=script&lang=ts"

import "./GridKPIAgenti.vue?vue&type=style&index=0&id=414b650a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-414b650a"]])

export default __exports__